import { emptyClusterInformation } from "../../../../constants";

const initialState = {
  clusterDetail: { ...emptyClusterInformation },
  editClusterDetail: {}
};

export default initialState;
